module.exports = __webpack_public_path__ + "static/media/icon-alert-solid.24c6fef9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-alert-solid.svg
// module id = 468
// module chunks = 0